import { useEffect, useState } from 'react';
import { device } from 'commons';

interface WindowSize {
  width: number;
  height: number;
}

interface ScreenInfo {
  windowSize: WindowSize;
  isMobile: boolean | undefined;
  isTablet: boolean | undefined;
  isSmallDesktop: boolean | undefined;
  isDesktop: boolean | undefined;
}

/**
 * Return an object containing the current
 * width and height of window object and booleans
 * to verify what is the current device
 * @returns {ScreenInfo} Updated screen values
 */
export function useScreenInfo(): ScreenInfo {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const [isMobile, setIsMobile] = useState<boolean | undefined>(undefined);
  const [isTablet, setIsTablet] = useState<boolean | undefined>(undefined);
  const [isSmallDesktop, setIsSmallDesktop] = useState<boolean | undefined>(
    undefined
  );
  const [isDesktop, setIsDesktop] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    function handleResize() {
      const { innerWidth: windowWidth, innerHeight: windowHeight } = window;
      const { mobile, tablet, desktopSmall } = device;

      setWindowSize({
        width: windowWidth,
        height: windowHeight,
      });

      setIsMobile(windowWidth <= mobile);
      setIsTablet(windowWidth > mobile && windowWidth <= tablet);
      setIsSmallDesktop(windowWidth > tablet && windowWidth <= desktopSmall);
      setIsDesktop(windowWidth > desktopSmall);
    }

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    windowSize,
    isMobile,
    isTablet,
    isSmallDesktop,
    isDesktop,
  };
}
